export default function AdminBehaviorEditBehaviorMap() {
  return <div className="">behavior map</div>;
}
